import EntityMapping from "@pages/EntityMapping";

export const EntityMappingRoutes = [
	{ path: "/configuration/entity-mapping", name: "configuration_mapping_entity_mapping", component: EntityMapping  },
]